// extracted by mini-css-extract-plugin
module.exports = {"home-page-hero":"homepage-hero_home-page-hero__keFPO","home-page-hero-bg":"homepage-hero_home-page-hero-bg__g2XOU","hero-text":"homepage-hero_hero-text___OQyg"};